<template>
    <div class="contact-form">
        <form>
            <div class="input-row">
                <div class="input-group">
                    <input type="text" name="name" placeholder="name">
                </div>

                <div class="input-group">
                    <input type="email" name="email" placeholder="email">
                </div>
            </div>
            <div class="input-row">
                <div class="input-group">
                    <textarea name="message" placeholder="Message"></textarea>
                </div>
            </div>
            <div class="input-row">
                <div class="input-group">
                    <button type="submit" class="theme-btn">
                        Submit Inquiry
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'ContactForm'
}
</script>